import type { TokaMapInstance } from '@tokamap/core';

/**
 * Arme ou range l'outil **zone d'analyse** (voir `MapLibreAdapter.startDrawingRegion`) — l'emprise
 * rectangulaire qu'on entoure sur la carte pour n'analyser qu'elle, plutôt que d'importer un
 * fichier de plan (voir `services/map/docs/PLAN_ANALYSE_ZONE_CARTE.md`).
 *
 * Partagé entre le panneau `PlanZoneSidebar` et le raccourci « Z » (`useKeyboardShortcuts`),
 * sur le modèle d'`openImportImageModal` : deux points d'entrée pour un seul comportement, et
 * surtout une seule définition de ce que « appuyer une deuxième fois » veut dire.
 *
 * Un deuxième appel RANGE l'outil sans effacer l'emprise déjà tracée : ranger et effacer sont deux
 * intentions distinctes côté `@tokamap/core`, et rien ici ne doit les confondre.
 *
 * L'instance est passée en paramètre plutôt que lue dans `currentEditorStore` : ce store tire
 * `@tokamap/core` en entier, donc `maplibre-gl`, qui ne s'importe pas sous jsdom
 * (`window.URL.createObjectURL` absent) — l'appelant l'a de toute façon déjà sous la main.
 */
export default function toggleRegionTool(instance: TokaMapInstance | null | undefined): void {
	if (!instance) return;

	const { mapAdapter } = instance;

	if (mapAdapter.isDrawingRegion()) return mapAdapter.stopDrawingRegion();

	return mapAdapter.startDrawingRegion();
}
